module.exports = __webpack_public_path__ + "img/43.6a60b73d.jpg";